module.exports = __webpack_public_path__ + "img/logo_rev.2d7fb486.png";